import { Component } from '@angular/core';
import { ClickedEmailLinkSearchResultDto } from 'src/app/communication/shared/clicked-email-link-search-result.dto';
import { ClickedEmailLinkSearchDto } from 'src/app/communication/shared/clicked-email-link-search.dto';
import { CommunicationService } from 'src/app/communication/shared/communication.service';
import { DatagridService, PagedResultGeneric } from 'src/app/shared';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

@Component({
  selector: 'wl-mass-comm-clicked-email-links-grid',
  templateUrl: './mass-comm-clicked-email-links-grid.component.html',
  styleUrl: './mass-comm-clicked-email-links-grid.component.less',
    standalone: false
})
export class MassCommClickedEmailLinksGridComponent extends LazySelectableTableComponent<
  ClickedEmailLinkSearchDto,
  ClickedEmailLinkSearchResultDto
> {
  constructor(private _communicationService: CommunicationService, datagridService: DatagridService) {
    super('', datagridService);
    this.searchParams = {
      PageNumber: 1,
      PageSize: 5,
    } as ClickedEmailLinkSearchDto;
  }

  fetchResults(): Promise<PagedResultGeneric<ClickedEmailLinkSearchResultDto>> {
    return this._communicationService.getTopFiveClickedLinks(this.searchParams).then((result) => {
      return {
        Result: result,
        PageSize: this.searchParams.PageSize,
        TotalPages: 1,
        CurrentPageNumber: 1,
      } as PagedResultGeneric<ClickedEmailLinkSearchResultDto>;
    });
  }
}
